export function assertDocRef(arg: any, where: string) {
  if ((arg as any)?._query) {
    console.error(`[Firestore] ${where}: expected DocumentReference but got Query`, arg);
    throw new Error(`${where}: got Query not DocumentReference`);
  }
  return arg;
}

export function assertQuery(arg: any, where: string) {
  if ((arg as any)?.id && (arg as any)?.path) {
    console.error(`[Firestore] ${where}: expected Query but got DocumentReference`, arg);
    throw new Error(`${where}: got DocumentReference not Query`);
  }
  return arg;
}
